import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Stack } from "@mui/material";
import { fetchProductReviews, approveProductReview, rejectProductReview } from '../service/productReview';

const ProductReviewManager = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch reviews
  const fetchReviews = async () => {
    setLoading(true);
    try {
      const response = await fetchProductReviews(); // adjust API path
      setReviews(response.data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // Approve review
  const handleApprove = async (reviewId) => {
    try {
      await  approveProductReview(reviewId); //axiosInstance.put(`/reviews/approve/${reviewId}`);
      fetchReviews(); // refresh
    } catch (error) {
      console.error("Error approving review:", error);
    }
  };

  // Reject review
  const handleReject = async (reviewId) => {
    try {
      await rejectProductReview(reviewId); //axiosInstance.put(`/reviews/reject/${reviewId}`);
      fetchReviews(); // refresh
    } catch (error) {
      console.error("Error rejecting review:", error);
    }
  };

  const columns = [
    { field: "reviewId", headerName: "ID", width: 90 },
    { field: "productId", headerName: "Product ID", width: 120 },
    { field: "userId", headerName: "User ID", width: 120 },
    { field: "rating", headerName: "Rating", width: 100 },
    { field: "title", headerName: "Title", width: 150 },
    { field: "reviewText", headerName: "Review", width: 250, flex: 1 },
    { field: "isApproved", headerName: "Approved?", width: 120 },
    { field: "isVerifiedPurchase", headerName: "Verified?", width: 120 },
    { field: "createdAt", headerName: "Created At", width: 180 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleApprove(params.row.reviewId)}
            disabled={params.row.isApproved}
          >
            Approve
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleReject(params.row.reviewId)}
            disabled={!params.row.isApproved}
          >
            Reject
          </Button>
        </Stack>
      ),
    },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <DataGrid
        rows={reviews}
        columns={columns}
        getRowId={(row) => row.reviewId}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        loading={loading}
        components={{ Toolbar: GridToolbar }}
      />
    </div>
  );
};

export default ProductReviewManager;
